import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';

import { ISpinnerState, SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'loading-spinner',
  template: `
    <div *ngIf="visible"
      class="spinner">
      <mat-spinner [color]="color"></mat-spinner>
    </div>
  `,
  styles: [`.spinner {position: fixed!important;top: 0;left: 0;height:100%;width:100%;background-color:rgba(128, 128, 128, 0.5);z-index:10000;display:flex;align-items:center;justify-content:center}`]
})

export class SpinnerComponent implements OnDestroy, OnInit {
  visible = false;
  color="warn";
  private _spinnerStateChanged: Subscription;

  constructor(private _spinnerService: SpinnerService) { }

  ngOnInit() {
    this._spinnerStateChanged = this._spinnerService.spinnerState
      .subscribe((state: ISpinnerState) => this.visible = state.show);
  }

  ngOnDestroy() {
    this._spinnerStateChanged.unsubscribe();
  }
}